export enum BanTypeEnum {
  GLOBAL = 'GLOBAL',
  EDIT_GLOBAL = 'EDIT_GLOBAL',
  COMPANY = 'COMPANY',
  COMPETITION = 'COMPETITION'
}
